import * as React from 'react';
import { CardMedia, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useLanguage } from "../../i18n/LanguageContext";

const content = {
    en: {
        nav: [["homeSection", "Home"], ["smartkeySection", "Smart Key"], ["aboutusSection", "About Us"], ["ourlocationSection", "Our Location"]],
        address: "TARQIA for Technology, San Jose, CA 95112, USA",
        rights: "© 2023 Tarqia All right reserved",
    },
    ar: {
        nav: [["homeSection", "الرئيسية"], ["smartkeySection", "ضياف"], ["aboutusSection", "من نحن"], ["ourlocationSection", "موقعنا"]],
        address: "ترقية للتقنية، سان خوسيه، كاليفورنيا 95112، الولايات المتحدة",
        rights: "© 2023 ترقية. جميع الحقوق محفوظة",
    },
};

const Footer = () => {

    const { lang } = useLanguage();
    const c = content[lang];

    const HandleNav = (section) => {
        document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <Box className="footerSection" id="contactusSection">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={3} lg={2} className="leftSectionFooter">
                        <CardMedia
                            style={{
                                width: "auto",
                                maxHeight: "200px",
                                marginTop: '30px'
                            }}
                            component="img"
                            image="icons/logobottom.svg"
                            alt="green iguana"
                            className="footerleftIcon"
                        />
                        <Box className="socialSection">
                            <Box sx={{ display: 'flex', m: 'auto', justifyContent: 'center' }} className="rightInnerSection">
                                <CardMedia
                                    style={{
                                        width: "50px",
                                        height: '50px',
                                        marginTop: '30px',
                                        marginRight: '10px'
                                    }}
                                    component="img"
                                    image="icons/fbicon.svg"
                                    alt="green iguana"
                                />
                                <CardMedia
                                    style={{
                                        width: "50px",
                                        height: '50px',
                                        marginTop: '30px'
                                    }}
                                    component="img"
                                    image="icons/linkedin.svg"
                                    alt="green iguana"
                                />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={8} md={6} lg={6} className="middleSectionFooter">
                        <Box className="footerNav">
                            {c.nav.map(([section, label]) => (
                                <Typography key={section} onClick={() => { HandleNav(section) }}>{label}</Typography>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={4} className="rightSectionFooter">

                        {/* New San Jose Address */}
                        <Typography className="address">{c.address}</Typography>
                        <Typography className="telEmail"><img src="/icons/tel.svg" alt="" /> <span dir="ltr">(408) 694-4186</span></Typography>
                        <Typography className="telEmail"><img src="/icons/mail.svg" alt="" /> <span dir="ltr">(408) 694-4189</span></Typography>
                    </Grid>
                    <Typography className="allRightReserve">
                        {c.rights}
                    </Typography>
                </Grid>
            </Box>
        </>
    );
};

export default Footer;
